export interface IUploadImagesFormFields {
    androidAppIconHDPIPortrait: string;
    androidAppIconXHDPIPortrait: string;
    androidAppIconXXHDPIPortrait: string;
    androidAppLogoHDPIPortrait: string;
    androidAppLogoXHDPIPortrait: string;
    androidSplashScreenHDPIPortrait: string;
    androidSplashScreenXHDPIPortrait: string;
    androidSplashScreenXXHDPIPortrait: string;
    iOS_AppDefaultIcon: string;
    // iosSplashScreenipad: string
    iOS_SplashScreeniphone: string;
    iOS_AppApplicationLogo: string;
}

export enum UploadImagesFormFields {
    androidAppIconHDPIPortrait = 'androidAppIconHDPIPortrait',
    androidAppIconXHDPIPortrait = 'androidAppIconXHDPIPortrait',
    androidAppIconXXHDPIPortrait = 'androidAppIconXXHDPIPortrait',
    androidAppLogoHDPIPortrait = 'androidAppLogoHDPIPortrait',
    androidAppLogoXHDPIPortrait = 'androidAppLogoXHDPIPortrait',
    androidSplashScreenHDPIPortrait = 'androidSplashScreenHDPIPortrait',
    androidSplashScreenXHDPIPortrait = 'androidSplashScreenXHDPIPortrait',
    androidSplashScreenXXHDPIPortrait = 'androidSplashScreenXXHDPIPortrait',
    // iosAppIconipad = 'iosAppIconipad',
    // iosAppIconiphone = 'iosAppIconiphone',
    iosAppDefaultIcon = 'iOS_AppDefaultIcon',
    iosAppApplicationLogo = 'iOS_AppApplicationLogo',
    // iosSplashScreenipad = 'iosSplashScreenipad',
    iosSplashScreeniphone = 'iOS_SplashScreeniphone'
}

export enum UploadImageNativeFileNames {
    androidAppLogoHDPIPortrait = 'Android_hdpi_Logo',
    androidAppLogoXHDPIPortrait = 'Android_xhdpi_Logo',
    androidAppIconHDPIPortrait = 'Android_hdpi_Icon',
    androidAppIconXHDPIPortrait = 'Android_xhdpi_Icon',
    androidAppIconXXHDPIPortrait = 'Android_xxhdpi_Icon',
    androidSplashScreenHDPIPortrait = 'Android_hdpi_Background',
    androidSplashScreenXHDPIPortrait = 'Android_xhdpi_Background',
    androidSplashScreenXXHDPIPortrait = 'Android_xxhdpi_Background',
    // iosAppIconipad = 'iOS_Icon_iPad',
    // iosAppIconiphone = 'iOS_Icon-iPhone@2x',
    iosAppDefaultIcon = 'iOS_AppDefaultIcon',
    // iosSplashScreenipad = 'iOS_SplashScreen_iPad',
    iosSplashScreeniphone = 'iOS_SplashScreeniphone',
    iosAppApplicationLogo = 'iOS_AppApplicationLogo'
}
